import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import cn from 'classnames';
import styles from './ServiceAndMaintenanceBookService.module.scss';

const BookService = ({ bookServiceData }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageField = bookServiceData?.image;
  const imageUrl = getImageUrl(imageField);
  const title = bookServiceData?.title || '';
  const textContent = bookServiceData?.text || '';
  const buttonText = bookServiceData?.buttonText || '';
  const buttonUrl = bookServiceData?.buttonUrl || '';

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <div className={styles.content}>
        {title && <h2 className={styles.content_title}>{title}</h2>}
        {textContent && (
          <div className={styles.content_text} dangerouslySetInnerHTML={{ __html: textContent }} />
        )}
        {buttonText && buttonUrl && (
          <div className={styles.content_buttonContainer}>
            <a href={buttonUrl} className={styles.content_buttonContainer_button}>
              {buttonText}
            </a>
          </div>
        )}
      </div>
      {imageUrl && (
        <div className={cn(styles.image, styles.imageDesktop)}>
          <img src={imageUrl} alt="Book service" />
        </div>
      )}
    </div>
  );
};

export default BookService;
